export var getIsActiveOption = function getIsActiveOption(_ref) {
  var option = _ref.option,
    activeOption = _ref.activeOption;
  var activeId = (activeOption === null || activeOption === void 0 ? void 0 : activeOption.slug) || (activeOption === null || activeOption === void 0 ? void 0 : activeOption.id);
  if (!activeId || !option.slug && !option.id) {
    return false;
  }
  return option.slug === activeId || option.id === activeId;
};